export default "__VITE_ASSET__CMxSmzBB__"